import { render, staticRenderFns } from "./CreateGameForm.vue?vue&type=template&id=11c634b6"
import script from "./CreateGameForm.vue?vue&type=script&lang=ts"
export * from "./CreateGameForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports